// /**
// * debounce function
// * Delays the processing of the event
// */
export const debounce = (callback: (args: unknown) => void, wait: number) => {
  let timerId: ReturnType<typeof setTimeout>;

  return (...args: [unknown]) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => {
      callback(...args);
    }, wait);
  };
};

interface IColorPalette {
  name: string;
  code: string;
}

export const darkColorPalette: Array<IColorPalette> = [
  { name: 'orange', code: '#f47920' },
  { name: 'yellow', code: '#f4b450' },
  { name: 'green', code: '#0f9d58' },
  { name: 'light-blue', code: '#009cde' }
];

export const lightColorPalette: Array<IColorPalette> = [
  { name: 'red', code: '#da291c' },
  { name: 'purple', code: '#492d8c' },
  { name: 'blue', code: '#2e67b2' },
  { name: 'orange', code: '#f47920' },
  { name: 'yellow', code: '#f4b450' },
  { name: 'green', code: '#0f9d58' },
  { name: 'light-blue', code: '#009cde' }
];

export const getRandomColor = (
  background: 'light' | 'dark' = 'light'
): IColorPalette => {
  if (background === 'light') {
    const lightRandomColor =
      lightColorPalette[Math.floor(Math.random() * lightColorPalette.length)];
    return lightRandomColor;
  }

  const darkRandomColor =
    darkColorPalette[Math.floor(Math.random() * darkColorPalette.length)];
  return darkRandomColor;
};
